import { render } from "./RidersList.vue?vue&type=template&id=788d4cf8&scoped=true"
import script from "./RidersList.vue?vue&type=script&lang=js"
export * from "./RidersList.vue?vue&type=script&lang=js"

import "./RidersList.vue?vue&type=style&index=0&id=788d4cf8&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788d4cf8"]])

export default __exports__